<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    if (localStorage.getItem('open-nickName')) {
      this.$store.state.login.isLogin = true
    }
    if (localStorage.getItem('open-userInfo') != '') {
      this.$store.state.login.userInfo = JSON.parse(localStorage.getItem('open-userInfo'))
    }

    // this.$store.state.login.userInfo = res.data.user
  },
}
</script>

<style>
::-webkit-scrollbar {
  display: none;
}

隐藏滚动条
.element {
  overflow: -moz-scrollbars-none;
  overflow: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

/* 滚动条样式 */
.element::-webkit-scrollbar {
  width: 0;
  height: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue